// extracted by mini-css-extract-plugin
export var active = "Values-module--active--340b9";
export var container = "Values-module--container--c57fd";
export var core = "Values-module--core--df181";
export var img = "Values-module--img--d0fef";
export var selector = "Values-module--selector--ff10a";
export var text = "Values-module--text--a123b";